import React from 'react';
import { Control, FieldError, FieldErrorsImpl, Merge, useController } from 'react-hook-form';

import { IconChevronDown } from '@/assets/icons';
import { cn } from '@/lib/utils';

interface Option {
  value: string;
  label: string;
}

interface SelectInputProps {
  name: string;
  control: Control<any>;
  label: string;
  rules?: any;
  className?: string;
  labelClassName?: string;
  fieldClassName?: string;
  options: Option[];
  placeholder?: string;
  errors?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
}

export const SelectInputField: React.FC<SelectInputProps> = ({
  name,
  control,
  className,
  labelClassName,
  fieldClassName,
  label,
  rules,
  options,
  placeholder = 'Select an option',
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue: '',
  });

  return (
    <div className={cn('-mt-2 flex flex-col gap-2', className)}>
      <label
        htmlFor={name}
        className={(cn('sky-mark-bold-16 text-primary-midnight block'), labelClassName)}
      >
        {label}
      </label>
      <div className="relative">
        <select
          id={name}
          {...field}
          className={cn(
            'sky-mark-regular-16 focus:border-primary-day-light border-neutral-light-grey placeholder:text-neutral-mid-grey disabled:bg-neutral-off-white flex h-10 w-full cursor-pointer appearance-none items-center rounded border-[1px] bg-white px-3 py-2 text-sm text-white focus:outline-0 focus:ring-0 disabled:cursor-not-allowed',
            {
              'border-secondary-red': error,
            },
            fieldClassName
          )}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {(options ?? []).map(option => (
            <option
              key={option.value}
              value={option.value}
              className="h-10 bg-[#363FBC52] text-sm text-white"
              style={{ backgroundColor: '#363FBC52' }}
            >
              {option.label}
            </option>
          ))}
        </select>
        <IconChevronDown className="pointer-events-none absolute right-4 top-1/2 size-6 -translate-y-1/2 text-white" />

        {/* <IconChevronDown className="pointer-events-none absolute inset-y-2.5 right-4 flex size-6 flex-col items-center text-white" /> */}
      </div>
      {error && <p className="text-secondary-red text-sm">{error.message}</p>}
    </div>
  );
};
